import { useState, useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'
import { CREATORS_QUERY_KEYS } from './use-creators'

const DEBOUNCE_MS = 300

export function useCommandSearch(query: string) {
  const [debouncedQuery, setDebouncedQuery] = useState('')

  useEffect(() => {
    const timer = setTimeout(
      () => setDebouncedQuery(query.length >= 2 ? query : ''),
      query.length < 2 ? 0 : DEBOUNCE_MS
    )

    return () => clearTimeout(timer)
  }, [query])

  const enabled = debouncedQuery.length >= 2

  const { data: creatorsData, isLoading } = useQuery({
    queryKey: CREATORS_QUERY_KEYS.list({ page: 1, limit: 5, search: debouncedQuery }),
    queryFn: () => api.creators.list(1, 5, debouncedQuery),
    enabled,
    placeholderData: (prev) => prev,
  })

  return {
    creators: enabled ? (creatorsData?.data ?? []) : [],
    isLoading: isLoading && enabled,
  }
}
